module.exports = __webpack_public_path__ + "assets/img/d9780c801c99f81dd143de36ab768ecc.svg";